import {Component, EventEmitter, Input, Output} from "@angular/core";
import {Names} from "../names";
import {SelectItem} from "primeng/primeng";


@Component({
    selector: Names.dropdown.selector,
    template: require("./dropdownComponent.html")
})

export class DropdownComponent {
    @Input("items") items: any;
    @Input("label") label: string;
    @Input("filter") filter: boolean = false;
    @Input("required") required: boolean;
    @Input("disabled") disabled: boolean = false;
    @Input("editable") editable: boolean = false;
    @Input("value") value: any = "";
    @Input("isPlaceholder") isPlaceholder: boolean = true;
    @Output("onSelected") onSelected: EventEmitter<{}>;

    options: SelectItem[];

    constructor() {
        this.onSelected = new EventEmitter();
    }

    ngOnChanges() {
        this.options = this.prepareData(this.items, this.label);
    }

    prepareData(items: any, label: string): SelectItem[] {
        var result: SelectItem[] = [];
        if (this.isPlaceholder) {
            result.push({
                label: "-Select-",
                value: -1
            });
        }
        if (items) {
            for (let item of items) {
                result.push({
                    label: item[label],
                    value: item
                });
            }
        }
        return result;
    }

    onChange(selectedValue: SelectItem) {
        this.onSelected.emit(selectedValue);
    }
}


// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/Dropdown/DropdownComponent.ts